(function () {
    'use strict';

    angular.module('Directives').directive('bbaZoneBasedMargins', bbaZoneBasedMargins);

    bbaZoneBasedMargins.$inject = [
        'ZoneBaseMarginsTableService',
        '$timeout'
    ];

    function bbaZoneBasedMargins(
        ZoneBaseMarginsTableService,
        $timeout
    ) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/margins/bba-zone-based-margins.html',
            require: ['^form', '^ngModel'],
            scope: {
                clearTable: '=?',
                isViewMode: '=?',
                ngModel: '=',
                ngOriginalData: '='
            },
            link: bbaZoneBasedMarginsLink
    }

        function bbaZoneBasedMarginsLink($scope, element, attr, ngModels) {
            $scope.zoneBaseMarginsTableService = new ZoneBaseMarginsTableService(
                ngModels[0],
                $scope.ngModel
            );
            $scope.addNewMargin = $scope.zoneBaseMarginsTableService.addNewMargin;
            $scope.postcodeMarginTable = $scope.zoneBaseMarginsTableService.tableData; 
            $scope.$watch('ngModel', (newValue, oldValue) => {
                if (newValue && angular.getObjVal(newValue ,'zoneMargins.regions')) {
                    $scope.zoneBaseMarginsTableService = new ZoneBaseMarginsTableService(
                        ngModels[0],
                        $scope.ngModel
                    );
                    $scope.addNewMargin = $scope.zoneBaseMarginsTableService.addNewMargin;
                    $scope.postcodeMarginTable = $scope.zoneBaseMarginsTableService.tableData;
                }
            });
            $scope.$watch('clearTable', function(value){
                if(value) {
                    let orignalCarrierProfile = $scope.ngOriginalData ? $scope.ngOriginalData.carrierProfile : undefined;
                    let newCarrierProfile = $scope.ngModel.carrierProfile;
                    if(angular.equals(orignalCarrierProfile, newCarrierProfile)){
                        $scope.zoneBaseMarginsTableService.resetTableData();
                    }
                    else {
                        $scope.postcodeMarginTable.data = [];
                        $scope.ngModel.regionsRaw = [];
                        $scope.clearTable = false;
                    }
                }
            });
            let listener = $scope.$on('postcodeMarginsTableUpdated', function (data) {
                $timeout(function () {
                    $scope.ngModel.regionsRaw = $scope.zoneBaseMarginsTableService.getPostcodeMarginFormatted();
                    $scope.ngModel.marginsFrmOpen = $scope.zoneBaseMarginsTableService.getOpenForms();
                });
            });
            $scope.$on('$destroy', function () {
                listener();
            });
        }
    }
})()


// WEBPACK FOOTER //
// ./js/directives/component/margins/bbaZoneBasedMargins.js